import { useTranslation } from 'react-i18next';
import { InstanceResponseModel } from '../../../../../apis/v1/instances/model';
import DialogBox from '../../../../../components/Atoms/DialogBox/DialogBox';
import { bandwidthPercent, formatBandwidth } from '@xver/utils/units';

interface BandwidthCardProps {
    bandwidth: InstanceResponseModel['bandwidth'];
}

export default function BandwidthCard({ bandwidth }: BandwidthCardProps) {
    const { t } = useTranslation('cloudComputeInstance');
    const usage = bandwidth?.usage ?? 0;
    const limit = bandwidth?.limit ?? 0;
    const pct = bandwidthPercent(usage, limit);

    return (
        <DialogBox
            label={t('bandwidth.title')}
            description={t('bandwidth.description')}
            classNames="p-4 gap-4"
        >
            <div className="w-full flex flex-row justify-between items-start gap-4">
                <div className="flex flex-col items-start">
                    <span className="text-sm text-fg/68" style={{ fontWeight: 400 }}>
                        {t('bandwidth.egressUsed')}
                    </span>
                    <div className="text-2xl font-semibold text-fg">
                        {formatBandwidth(usage)}
                        <span className="text-base text-fg/68 font-normal">
                            {' '}
                            / {formatBandwidth(limit)}
                        </span>
                    </div>
                </div>
                <div className="flex flex-col items-end">
                    <span className="text-sm text-fg/68">{t('bandwidth.overageRate')}</span>
                    <div className="text-base text-fg">
                        {t('bandwidth.overageRateValue')}{' '}
                        <span className="text-fg/68">{t('bandwidth.perGb')}</span>
                    </div>
                </div>
            </div>
            <div className="w-full h-2 rounded-full bg-surface-3 overflow-hidden">
                <div className="h-full" style={{ width: `${pct}%`, backgroundColor: '#14b8a6' }} />
            </div>
        </DialogBox>
    );
}
